import { render, staticRenderFns } from "./BathTable.vue?vue&type=template&id=7dd631e2&scoped=true"
import script from "./BathTable.vue?vue&type=script&lang=js"
export * from "./BathTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd631e2",
  null
  
)

export default component.exports